import React, { Component } from 'react';

import api from '../../config/api';
import {completeUrlForArticle, getDateByLocaleFormat} from "../../util/utils";
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";

class ArticleDetailsPage extends Component {

	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.state = {
			selectedArticle: {},
		};
	}

	componentWillMount() {
		const {selectedLanguage} = this.props;
		this.loadArticle(selectedLanguage);
	}

	componentWillReceiveProps(nextProps) {
		const {selectedLanguage, match} = nextProps;
		if(this.props.match.url !== match.url) {
			this.setState({
				selectedArticle: {},
				images: []
			});
			this.loadArticle(selectedLanguage);
		}
	}

	/**
	 * Get ID from url
	 * @returns {*}
	 */
	getIdFromUrl = () => {
		return this.props.match.params.articleUrl.split('-')[0];
	};

	/**
	 * Load product from API
	 */
	loadArticle = (language) => {
		fetch(api.articleDetails(this.getIdFromUrl()))
			.then(res => res.json())
			.then(data => {
				this.setState({
					selectedArticle: completeUrlForArticle(data)
				});
			}).catch(err => console.error(err));
	};

	renderBanner = (article) => {
		if(article.image === null){
			return null;
		}
		const style = {
			backgroundImage: "url("+article.image+""
		};
		return <div className="page__banner page__banner--article-details" style={style} />;
	};

	render() {
		const { localizePath, selectedLanguage } = this.props;
		const article = this.state.selectedArticle;
		return (
			<div className="container-flex">
				{this.renderBanner(article)}
				<div className="page">
					<article className="page__content page__content--article-details">
						<h2 className="article-title">
							{article.title}
						</h2>
						<section className="article-date">
							{getDateByLocaleFormat(article.createdAt,selectedLanguage.codeCountry)}
						</section>
						<section className="article-prolog">{article.prolog}</section>
						<section className="article-content"
						     dangerouslySetInnerHTML={ {__html: article.content} }/>
						<div className="article-redirect">
							<Link className="btn btn-all-article" to={localizePath("/articles")}>
								<FormattedMessage id="home.article.all" />
								<i className="fa fa-angle-right"/>
							</Link>
						</div>
					</article>
				</div>
			</div>
		);
	}
}

export default ArticleDetailsPage;


// WEBPACK FOOTER //
// ./src/components/page/ArticleDetailsPage.js